/* ============================
    IMPORTS & ROUTING PACKAGES
   ============================ */
import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Login from "./components/Login";
import Register from "./components/Register";
import Dashboard from "./components/Dashboard";

/* =============================
    ROOT APPLICATION ENTRYPOINT
   ============================= */
export default function App() {
  return (
    /* Router & Auth Context Wrap */
    <Router>
      <AuthProvider>
        
        {/* Application Routes Switch Directory */}
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>

      </AuthProvider>
    </Router>
  );
}